import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import ApprovalEntity from "../../components/examReport/ApprovalEntity";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId,
  getAnswerKeyDataBySubjectId,
  updateAnswerKeyData,
  getAllApprovalAnswerKeyListPagination,
  getObjectiveStatusflag,
} from "../../actions/postExaminationProcessObjectiveActions";
import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";
import { GET_ALL_ANSWER_KEY_DATA, SET_OBJECTIVE_STATUS_DATA_FLAG } from "../../../common/constants/ActionTypes";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Approvals",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "All Answer Key",
  },
];

const AnswerKeyReport = () => {

  const pdfRef = useRef(null);


  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  let {
    examList,
    advertisementList,
    subjectList,
    getAnswerKeyData,
    allUnapprovalEntityList,

    unapprovalPageNoCounter,
    objectiveStatusDataFlag,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);


  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );



  let tableCounter_unapproval = unapprovalPageNoCounter + 1;
  let rowPerPage = 10;


  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [editedValues, setEditedValues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [allAnswerValues, setAllAnswerValues] = useState([]);
  const [stepName, setName] = useState("2");
  const [selectedYear, setSelectedYear] = useState("");
  const [flagArray, setFlagArray] = useState([]);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const [questionSet, setQuestionSet] = useState("");
  const [totalQuestions, setTotalQuestions] = useState("");
  const [marksPerQuestion, setMarksPerQuestion] = useState("");
  const [totalMarks, setTotalMarks] = useState(0);

  const dispatch = useDispatch();
  useEffect(() => {
    if (getAnswerKeyData.answers) {
      setAllAnswerValues(getAnswerKeyData.answers);
    }
    else {
      setAllAnswerValues([])
    }
  }, [getAnswerKeyData]);

  useEffect(() => {
    if (allAnswerValues.length !== 0) {
      setSaveButtonFlag(false);
    }
  }, [allAnswerValues.length, setSaveButtonFlag]);

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getYearList());
    onCancelButton();
    dispatch({
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      payload: []
    });
    flagArray.length = 0;
    // dispatch(getAllApprovalAnswerKeyListPagination(0, rowPerPage));
    // setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepName === "1") {
      dispatch(
        getAllApprovalAnswerKeyListPagination(listCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepName]);

  useEffect(() => {
    setFlagArray([]);
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      const flagArrayBeforeInterviewCriteria = [];

      // for (let i = 0; i < flagValues.length; i++) {
      //   if (flagValues[i] === "Answer Key") {
      //     setFlagArray(flagArrayBeforeInterviewCriteria);
      //     break;
      //   } else {
      //     flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
      //   }
      // }
      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Answer Key") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          if (objectiveStatusDataFlag[i].flagStatus === true) {
            flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
          }
        }
      }
    }
  }, [objectiveStatusDataFlag]);

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    setSelectedExam("");
    setFlagArray([]);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
    // setAllAnswerValues([]);
    dispatch({
      type: GET_ALL_ANSWER_KEY_DATA,
      payload: []
    })
    setEditMode(false);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    Promise.resolve()
      .then(() => {

        subjectList.length = 0;
        setSelectedExam(selectedValue);


        return dispatch(getObjectiveStatusflag(selectedValue));
      })
      .then(() => {

        setSelectedSubject("");
        setSaveButtonFlag(true);


        if (selectedValue) {
          return dispatch(getSubjectlistByExamId(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        setReloadItem((prev) => !prev);


        return dispatch({
          type: GET_ALL_ANSWER_KEY_DATA,
          payload: []
        });
      })
      .then(() => {

        setEditMode(false);
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };


  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      // setAllAnswerValues([]);
      dispatch({
        type: GET_ALL_ANSWER_KEY_DATA,
        payload: []
      })
      setSaveButtonFlag(true);
      setFlagArray([]);
      setReloadItem(!reloadItem);
    }

  };

  // const onSubjectChange = (ele) => {
  //   let selectedValue = ele;
  //   setSelectedSubject(selectedValue);
  //   onSubmit(selectedValue);
  //   setReloadItem(!reloadItem);
  //   // setAllAnswerValues([]);
  //   dispatch({
  //     type: GET_ALL_ANSWER_KEY_DATA,
  //     payload: []
  //   })
  //   setEditedValues({});
  //   setEditMode(false);
  // };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);

    // reset config
    setQuestionSet("");
    setTotalQuestions("");
    setMarksPerQuestion("");
    setTotalMarks(0);

    onSubmit(selectedValue);
    setReloadItem(!reloadItem);

    dispatch({
      type: GET_ALL_ANSWER_KEY_DATA,
      payload: []
    });

    setEditedValues({});
    setEditMode(false);
  };


  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    setFlagArray([]);
    setEditedValues({});
    dispatch({
      type: GET_ALL_ANSWER_KEY_DATA,
      payload: []
    })
    setEditMode(false);
  };

  const onSubmit = (selectedSubject) => {

    dispatch(getAnswerKeyDataBySubjectId(selectedExam, selectedSubject));
    setReloadItem(!reloadItem);


  };

  const genPdf = () => {
    let headerDiv = ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' + label.MPSC + '</h5><h5>' + getAnswerKeyData.examName + '</h5><h5>' + label.AnswerKey + '(' + getAnswerKeyData.subjectName + ')</h5></div>';
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    const examName = getAnswerKeyData.examName;
    const subjectName = getAnswerKeyData.subjectName;

    const options = {
      margin: [1, 0.4, 0.7, 0.4],
      filename: "AnswerKeyReport.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.4;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = getAnswerKeyData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`AnswerKeyReport_${examName}_${subjectName}.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };

  const firstSetOfQuestions = allAnswerValues.slice(0, 100);
  const secondSetOfQuestions = allAnswerValues.slice(100, 200);

  const firstColumn = [
    ...firstSetOfQuestions.slice(0, 50),
    ...secondSetOfQuestions.slice(0, 50)
  ];

  const secondColumn = [
    ...firstSetOfQuestions.slice(50, 100),
    ...secondSetOfQuestions.slice(50, 100)
  ];

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  // const handleConfirmButtonClick = () => {
  //   dispatch(updateAnswerKeyData(selectedExam, selectedSubject, editedValues));
  //   setEditMode(false);
  //   setSaveButtonFlag(true);
  //   setReloadItem(!reloadItem);
  //   onCancelButton();
  // };
  const handleConfirmButtonClick = () => {
    if (!questionSet || !totalQuestions || !marksPerQuestion) {
      alert("Please fill Answer Key Configuration fields");
      return;
    }

    dispatch(
      updateAnswerKeyData(selectedExam, selectedSubject, {
        ...editedValues,
        questionSet,
        totalQuestions,
        marksPerQuestion,
        totalMarks
      })
    );

    setEditMode(false);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    onCancelButton();
  };



  const handleInputChange = (index, key, value) => {
    setEditedValues((prevValues) => ({
      ...prevValues,
      [index]: {
        ...prevValues[index],
        [key]: value,
      },
    }));
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  useEffect(() => {
    if (totalQuestions && marksPerQuestion) {
      setTotalMarks(Number(totalQuestions) * Number(marksPerQuestion));
    } else {
      setTotalMarks(0);
    }
  }, [totalQuestions, marksPerQuestion]);


  return (
    <div className="commonContentArea">
      <h5 className="ml-3"> {label.AnswerKeyReport} </h5>

      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {allUnapprovalEntityList &&
              allUnapprovalEntityList.entityApprovalDtoList &&
              allUnapprovalEntityList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th key={ind}
                            className={`${itm === 'No.' || itm === 'Action' ? 'text-center' : ''
                              }`}>
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allUnapprovalEntityList &&
                      allUnapprovalEntityList.entityApprovalDtoList &&
                      allUnapprovalEntityList.entityApprovalDtoList.length >
                      0 &&
                      allUnapprovalEntityList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break  width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.nameDvng}
                              </td>
                              <td className="w-10 word-break width-12">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject.nameDvng}
                              </td>
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className="word-break width-10">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-15">
                                {(session.roleName == 'superadmin' || session.roleName == 'desk officer') &&
                                  <button
                                    type="button"
                                    className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {label.REVIEW}
                                  </button>}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalEntityList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          value={selectedYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList
                              .map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                        </select>
                        {_.get("selectedYear.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedSubject"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSubjectChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              // .filter(
                              //   (element) =>
                              //     element.isDeleted == false &&
                              //     element.isActive === true
                              // )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name} ({element.type?.toUpperCase()})
                                </option>
                              ))}
                        </select>
                        {_.get("selectedSubject.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="row pl-3 pr-3">
                      {flagArray &&
                        flagArray.length > 0 &&
                        flagArray.map((ele, index) => (
                          <div className="d-flex p-2" key={index}>
                            <input
                              type="checkbox"
                              disabled
                              checked={ele.flagStatus === true && true}
                              className="form-control"
                            />
                            <label className="ml-1">{ele.flag}</label>
                          </div>
                        ))}
                    </div>

                    <div className="row">
                      <div className="form-group col-md-8">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || editMode}
                          onClick={handleEditButtonClick}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || !editMode}
                          onClick={handleConfirmButtonClick}
                        >
                          {commonLabels.BUTTON_CONFIRM}
                        </button>

                        {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || editMode}
                          onClick={() => {
                            downloadPdf();
                          }}
                        >
                          {commonLabels.BUTTON_PRINT}
                        </button>}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {allAnswerValues && allAnswerValues.length > 0 && (
              <div ref={pdfRef} className="answerKeyTable" id="AnswerKey">


                <table className="table text-center">
                  <thead className="bold-label">
                    <tr>
                      <th className="text-center" id="bordered">{label.QUESTION_NO}</th>
                      <th id="bordered">{label.A}</th>
                      <th id="bordered">{label.B}</th>
                      <th id="bordered">{label.C}</th>
                      <th id="bordered">{label.D}</th>
                      <th id="borderless"></th>
                      <th className="text-center" id="bordered">{label.QUESTION_NO}</th>
                      <th id="bordered">{label.A}</th>
                      <th id="bordered">{label.B}</th>
                      <th id="bordered">{label.C}</th>
                      <th id="bordered">{label.D}</th>
                    </tr>
                    <tr id="height10px"></tr>
                  </thead>
                  <tbody>
                    {firstColumn.map((answer, index) => (
                      <>
                        <tr key={index} id="height10px">
                          <td className="text-center" id="bordered"><strong>{answer.q}</strong></td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                defaultValue={answer.A}
                                pattern="^(A|B|C|D|G)$"
                                value={editedValues[answer.q]?.A}
                                onChange={(e) => handleInputChange(answer.q, 'A', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];
                                  
                                  {console.log(input)}
                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : answer.A} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={answer.A}
                                value={editedValues[answer.q]?.A} // Controlled input
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase(); // Convert to uppercase
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);

                                  // Update state only if the input is valid or empty
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(answer.q, 'A', input); // Call with the valid input
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  // Prevent default if the key is not allowed
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault(); // Block any invalid key press
                                  }
                                }}
                                maxLength={1} // Limit input length to 1 character
                              />
                            ) : (
                              answer.A
                            )}
                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={answer.B}
                                value={editedValues[answer.q]?.B}
                                onChange={(e) => handleInputChange(answer.q, 'B', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : answer.B} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={answer.B}
                                value={editedValues[answer.q]?.B} // Controlled input
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase(); // Convert to uppercase
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);

                                  // Update state only if the input is valid or empty
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(answer.q, 'B', input); // Call with the valid input
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  // Prevent default if the key is not allowed
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault(); // Block any invalid key press
                                  }
                                }}
                                maxLength={1} // Limit input length to 1 character
                              />
                            ) : (
                              answer.B
                            )}
                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={answer.C}
                                value={editedValues[answer.q]?.C}
                                onChange={(e) => handleInputChange(answer.q, 'C', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : answer.C} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={answer.C}
                                value={editedValues[answer.q]?.C} // Controlled input
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase(); // Convert to uppercase
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);

                                  // Update state only if the input is valid or empty
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(answer.q, 'C', input); // Call with the valid input
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  // Prevent default if the key is not allowed
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault(); // Block any invalid key press
                                  }
                                }}
                                maxLength={1} // Limit input length to 1 character
                              />
                            ) : (
                              answer.C
                            )}
                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={answer.D}
                                value={editedValues[answer.q]?.D}
                                onChange={(e) => handleInputChange(answer.q, 'D', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : answer.D} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={answer.D}
                                value={editedValues[answer.q]?.D} // Controlled input
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase(); // Convert to uppercase
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);

                                  // Update state only if the input is valid or empty
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(answer.q, 'D', input); // Call with the valid input
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  // Prevent default if the key is not allowed
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault(); // Block any invalid key press
                                  }
                                }}
                                maxLength={1} // Limit input length to 1 character
                              />
                            ) : (
                              answer.D
                            )}
                          </td>
                          <td id="width5px"></td>
                          <td className="text-center" id="bordered"><strong>{secondColumn[index]?.q}</strong></td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={secondColumn[index]?.A}
                                value={editedValues[secondColumn[index]?.q]?.secondA}
                                onChange={(e) => handleInputChange(secondColumn[index]?.q, 'A', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : secondColumn[index]?.A} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={secondColumn[index]?.A}
                                value={editedValues[secondColumn[index]?.q]?.A}
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase();
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(secondColumn[index]?.q, 'A', input);
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault();
                                  }
                                }}
                                maxLength={1}
                              />
                            ) : (
                              secondColumn[index]?.A
                            )}

                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={secondColumn[index]?.B}
                                value={editedValues[secondColumn[index]?.q]?.secondB}
                                onChange={(e) => handleInputChange(secondColumn[index]?.q, 'B', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : secondColumn[index]?.B} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={secondColumn[index]?.B}
                                value={editedValues[secondColumn[index]?.q]?.B}
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase();
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(secondColumn[index]?.q, 'B', input);
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault();
                                  }
                                }}
                                maxLength={1}
                              />
                            ) : (
                              secondColumn[index]?.B
                            )}
                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={secondColumn[index]?.C}
                                value={editedValues[secondColumn[index]?.q]?.secondC}
                                onChange={(e) => handleInputChange(secondColumn[index]?.q, 'C', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : secondColumn[index]?.C} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={secondColumn[index]?.C}
                                value={editedValues[secondColumn[index]?.q]?.C}
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase();
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(secondColumn[index]?.q, 'C', input);
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault();
                                  }
                                }}
                                maxLength={1}
                              />
                            ) : (
                              secondColumn[index]?.C
                            )}
                          </td>
                          <td id="bordered">
                            {/* {editMode ? (
                              <input
                                type="text"
                                pattern="^(A|B|C|D|G)$"
                                defaultValue={secondColumn[index]?.D}
                                value={editedValues[secondColumn[index]?.q]?.secondD}
                                onChange={(e) => handleInputChange(secondColumn[index]?.q, 'D', e.target.value)}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyPress={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];

                                  if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 1) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ) : secondColumn[index]?.D} */}
                            {editMode ? (
                              <input
                                type="text"
                                defaultValue={secondColumn[index]?.D}
                                value={editedValues[secondColumn[index]?.q]?.D}
                                onChange={(e) => {
                                  const input = e.target.value.toUpperCase();
                                  const allowedChars = new Set(['A', 'B', 'C', 'D', 'G']);
                                  if (allowedChars.has(input) || input === '') {
                                    handleInputChange(secondColumn[index]?.q, 'D', input);
                                  }
                                }}
                                className={editMode ? "editable-input-box" : "input-box"}
                                onKeyDown={(e) => {
                                  const input = e.key.toUpperCase();
                                  const allowedChars = ['A', 'B', 'C', 'D', 'G'];
                                  if (!allowedChars.includes(input) && input.length === 1) {
                                    e.preventDefault();
                                  }
                                }}
                                maxLength={1}
                              />
                            ) : (
                              secondColumn[index]?.D
                            )}
                          </td>
                        </tr>
                        <tr id="height10px"></tr>
                      </>
                    ))}
                  </tbody>
                </table>

              </div>
            )}
          </div>
          {approvalEntityModal && (
            <ApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default AnswerKeyReport;
